// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-picker-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }
  
  .date-picker-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
    background: white;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding: 10px;
    overflow: hidden;
    width: max-content;
  }

  .rdrInputRanges {
    display: none;
  }

  .rdrStaticRanges{
    height: max-content !important;
  }

  
  .date-picker-dropdown.adjust-right {
    right: 0;
    left: auto;
  }
  
  .total-row {
    background-color: #f0f8ff;
    font-weight: bold;
  }
  
  .total-row:hover > td {
    background-color: #f0f0f0 !important;
  }
  
  .hover-row:hover {
    background-color: #f5f5f5;
  }
  
  /* Add styles for the source analysis tab */
  .source-analysis-container {
    margin-top: 20px;
  }
  
  .source-card {
    margin-bottom: 20px;
  }
  
  .source-chart-container {
    height: 400px;
    width: 100%;
  }
  
  .analytics-header {
    .org-select {
      .ant-select-selector {
        min-height: 36px !important;
        padding: 2px 8px !important;
        border-color: #e2e8f0 !important;
        border-radius: 6px !important;
        
        &:hover {
          border-color: #3b82f6 !important;
        }
      }

      &.ant-select-focused .ant-select-selector {
        border-color: #3b82f6 !important;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
      }

      .ant-select-selection-placeholder {
        line-height: 32px !important;
        color: #94a3b8 !important;
      }

      .ant-select-selection-item {
        line-height: 30px !important;
        color: #334155 !important;
      }

      .ant-select-selection-search-input {
        height: 32px !important;
      }
    }

    .date-range-input {
      &:hover {
        border-color: #3b82f6 !important;
      }

      &:focus {
        border-color: #3b82f6 !important;
        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
      }

      input {
        cursor: pointer !important;
        color: #334155 !important;
      }

      .anticon {
        color: #64748b !important;
      }
    }
  }

  /* Date Range Picker Customization */
  .rdrCalendarWrapper {
    font-size: 14px !important;
    background-color: #fff !important;
    border-radius: 8px !important;
    overflow: hidden !important;
  }

  .rdrDateDisplayWrapper {
    background-color: #f8fafc !important;
  }

  .rdrDateDisplay {
    margin: 0.8em !important;
  }

  .rdrDefinedRangesWrapper {
    border-right: 1px solid #e2e8f0 !important;
    background-color: #f8fafc !important;
    font-size: 14px !important;
  }

  .rdrStaticRange {
    border-bottom: 1px solid #e2e8f0 !important;
    background-color: #f8fafc !important;
    color: #475569 !important;
    
    &:hover, &:focus {
      background-color: #f1f5f9 !important;
    }

    &.rdrStaticRangeSelected {
      background-color: #dbeafe !important;
      color: #1e40af !important;
    }
  }

  .rdrInputRange {
    padding: 0.8em !important;
  }

  .rdrMonth {
    padding: 0 0.8em 0.8em !important;
  }

  .rdrMonthName {
    color: #475569 !important;
    font-weight: 500 !important;
    padding: 0.8em !important;
  }

  .rdrWeekDay {
    color: #64748b !important;
    font-weight: 400 !important;
  }

  .rdrDay {
    margin-top: 0.4em !important;
    color: #334155 !important;

    &.rdrDayDisabled {
      color: #cbd5e1 !important;
    }

    &.rdrDayToday .rdrDayNumber span:after {
      background: #3b82f6 !important;
    }
  }

  .rdrDayHovered {
    border-radius: 4px !important;
    background-color: #f1f5f9 !important;
  }

  .rdrDayActive {
    border-radius: 4px !important;
    background-color: #3b82f6 !important;
    color: #fff !important;
  }

  .rdrInRange {
    background-color: #dbeafe !important;
    color: #1e40af !important;
  }

  .rdrStartEdge, .rdrEndEdge {
    background-color: #3b82f6 !important;
    border-radius: 4px !important;
    color: #fff !important;
  }
  
/* DateRangePicker Custom Styles */
.rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,
.rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
  color: #000 !important;
}

.rdrMonthAndYearPickers select {
  color: #000;
}

.rdrDateDisplayItem {
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.rdrDateDisplayItem input {
  color: #000;
}

.rdrMonthAndYearWrapper {
  padding-top: 0;
}
  `, "",{"version":3,"sources":["webpack://./src/components/Admin/Adminanalytics.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,aAAa;IACb,iBAAiB;IACjB,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;;EAGA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,2CAA2C;EAC3C;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE;MACE;QACE,2BAA2B;QAC3B,2BAA2B;QAC3B,gCAAgC;QAChC,6BAA6B;;QAE7B;UACE,gCAAgC;QAClC;MACF;;MAEA;QACE,gCAAgC;QAChC,wDAAwD;MAC1D;;MAEA;QACE,4BAA4B;QAC5B,yBAAyB;MAC3B;;MAEA;QACE,4BAA4B;QAC5B,yBAAyB;MAC3B;;MAEA;QACE,uBAAuB;MACzB;IACF;;IAEA;MACE;QACE,gCAAgC;MAClC;;MAEA;QACE,gCAAgC;QAChC,wDAAwD;MAC1D;;MAEA;QACE,0BAA0B;QAC1B,yBAAyB;MAC3B;;MAEA;QACE,yBAAyB;MAC3B;IACF;EACF;;EAEA,oCAAoC;EACpC;IACE,0BAA0B;IAC1B,iCAAiC;IACjC,6BAA6B;IAC7B,2BAA2B;EAC7B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,0CAA0C;IAC1C,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,2CAA2C;IAC3C,oCAAoC;IACpC,yBAAyB;;IAEzB;MACE,oCAAoC;IACtC;;IAEA;MACE,oCAAoC;MACpC,yBAAyB;IAC3B;EACF;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;IAC5B,yBAAyB;;IAEzB;MACE,yBAAyB;IAC3B;;IAEA;MACE,8BAA8B;IAChC;EACF;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,6BAA6B;IAC7B,oCAAoC;IACpC,sBAAsB;EACxB;;EAEA;IACE,oCAAoC;IACpC,yBAAyB;EAC3B;;EAEA;IACE,oCAAoC;IACpC,6BAA6B;IAC7B,sBAAsB;EACxB;;AAEF,kCAAkC;AAClC;;;;;;;;EAQE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".date-picker-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n  \n  .date-picker-dropdown {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    z-index: 1000;\n    background: white;\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 4px;\n    padding: 10px;\n    overflow: hidden;\n    width: max-content;\n  }\n\n  .rdrInputRanges {\n    display: none;\n  }\n\n  .rdrStaticRanges{\n    height: max-content !important;\n  }\n\n  \n  .date-picker-dropdown.adjust-right {\n    right: 0;\n    left: auto;\n  }\n  \n  .total-row {\n    background-color: #f0f8ff;\n    font-weight: bold;\n  }\n  \n  .total-row:hover > td {\n    background-color: #f0f0f0 !important;\n  }\n  \n  .hover-row:hover {\n    background-color: #f5f5f5;\n  }\n  \n  /* Add styles for the source analysis tab */\n  .source-analysis-container {\n    margin-top: 20px;\n  }\n  \n  .source-card {\n    margin-bottom: 20px;\n  }\n  \n  .source-chart-container {\n    height: 400px;\n    width: 100%;\n  }\n  \n  .analytics-header {\n    .org-select {\n      .ant-select-selector {\n        min-height: 36px !important;\n        padding: 2px 8px !important;\n        border-color: #e2e8f0 !important;\n        border-radius: 6px !important;\n        \n        &:hover {\n          border-color: #3b82f6 !important;\n        }\n      }\n\n      &.ant-select-focused .ant-select-selector {\n        border-color: #3b82f6 !important;\n        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n      }\n\n      .ant-select-selection-placeholder {\n        line-height: 32px !important;\n        color: #94a3b8 !important;\n      }\n\n      .ant-select-selection-item {\n        line-height: 30px !important;\n        color: #334155 !important;\n      }\n\n      .ant-select-selection-search-input {\n        height: 32px !important;\n      }\n    }\n\n    .date-range-input {\n      &:hover {\n        border-color: #3b82f6 !important;\n      }\n\n      &:focus {\n        border-color: #3b82f6 !important;\n        box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;\n      }\n\n      input {\n        cursor: pointer !important;\n        color: #334155 !important;\n      }\n\n      .anticon {\n        color: #64748b !important;\n      }\n    }\n  }\n\n  /* Date Range Picker Customization */\n  .rdrCalendarWrapper {\n    font-size: 14px !important;\n    background-color: #fff !important;\n    border-radius: 8px !important;\n    overflow: hidden !important;\n  }\n\n  .rdrDateDisplayWrapper {\n    background-color: #f8fafc !important;\n  }\n\n  .rdrDateDisplay {\n    margin: 0.8em !important;\n  }\n\n  .rdrDefinedRangesWrapper {\n    border-right: 1px solid #e2e8f0 !important;\n    background-color: #f8fafc !important;\n    font-size: 14px !important;\n  }\n\n  .rdrStaticRange {\n    border-bottom: 1px solid #e2e8f0 !important;\n    background-color: #f8fafc !important;\n    color: #475569 !important;\n    \n    &:hover, &:focus {\n      background-color: #f1f5f9 !important;\n    }\n\n    &.rdrStaticRangeSelected {\n      background-color: #dbeafe !important;\n      color: #1e40af !important;\n    }\n  }\n\n  .rdrInputRange {\n    padding: 0.8em !important;\n  }\n\n  .rdrMonth {\n    padding: 0 0.8em 0.8em !important;\n  }\n\n  .rdrMonthName {\n    color: #475569 !important;\n    font-weight: 500 !important;\n    padding: 0.8em !important;\n  }\n\n  .rdrWeekDay {\n    color: #64748b !important;\n    font-weight: 400 !important;\n  }\n\n  .rdrDay {\n    margin-top: 0.4em !important;\n    color: #334155 !important;\n\n    &.rdrDayDisabled {\n      color: #cbd5e1 !important;\n    }\n\n    &.rdrDayToday .rdrDayNumber span:after {\n      background: #3b82f6 !important;\n    }\n  }\n\n  .rdrDayHovered {\n    border-radius: 4px !important;\n    background-color: #f1f5f9 !important;\n  }\n\n  .rdrDayActive {\n    border-radius: 4px !important;\n    background-color: #3b82f6 !important;\n    color: #fff !important;\n  }\n\n  .rdrInRange {\n    background-color: #dbeafe !important;\n    color: #1e40af !important;\n  }\n\n  .rdrStartEdge, .rdrEndEdge {\n    background-color: #3b82f6 !important;\n    border-radius: 4px !important;\n    color: #fff !important;\n  }\n  \n/* DateRangePicker Custom Styles */\n.rdrDayToday:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.rdrDayToday:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.rdrDayToday:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.rdrDayToday:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span,\n.rdrDay:not(.rdrDayPassive) .rdrInRange ~ .rdrDayNumber span,\n.rdrDay:not(.rdrDayPassive) .rdrStartEdge ~ .rdrDayNumber span,\n.rdrDay:not(.rdrDayPassive) .rdrEndEdge ~ .rdrDayNumber span,\n.rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {\n  color: #000 !important;\n}\n\n.rdrMonthAndYearPickers select {\n  color: #000;\n}\n\n.rdrDateDisplayItem {\n  border-radius: 4px;\n  background-color: #fff;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.rdrDateDisplayItem input {\n  color: #000;\n}\n\n.rdrMonthAndYearWrapper {\n  padding-top: 0;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
